import { FC, useCallback, memo } from 'react';
import { useWebSocket } from 'src/hooks/useWebSocket';

const UserWebSocket: FC = memo(() => {
  const genericHandler = useCallback(
    (eventType: string, data: unknown): void => {
      const event = new CustomEvent('UserWebSocketEvent', {
        detail: { data, type: eventType },
      });
      document.dispatchEvent(event);
    },
    []
  );

  useWebSocket({
    enabled: true,
    url: 'user/',
    genericHandler,
    reconnectAttempts: 5,
    reconnectDelay: 3000,
  });

  return null;
});

UserWebSocket.displayName = 'UserWebSocket';

export default UserWebSocket;
